var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.123,
    height: 19.077,
    viewBox: "0 0 19.123 19.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.596)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77,15.092a6.652,6.652,0,0,1-1.711-2.448A6.72,6.72,0,0,1,4.448,5.428L6.209,7.189A.18.18,0,0,0,6.5,7.073l.962-6.3A.157.157,0,0,0,7.288.6l-6.3.962a.18.18,0,0,0-.116.295L2.636,3.62A9.263,9.263,0,0,0,9.464,19.364l.4-2.588A6.721,6.721,0,0,1,4.77,15.092Z",
    transform: "translate(0 -0.596)",
    fill: "#9999bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.965,24.237a9.263,9.263,0,0,0-6.828-15.744l-.4,2.588a6.726,6.726,0,0,1,5.09,1.684,6.652,6.652,0,0,1,1.711,2.448,6.72,6.72,0,0,1-1.389,7.216l-1.761-1.761a.18.18,0,0,0-.295.116l-.962,6.3a.157.157,0,0,0,.178.178l6.3-.962A.182.182,0,0,0,247.73,26Z",
    transform: "translate(-229.478 -8.184)",
    fill: "#9999bf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c96c223df9d3235f2a309e962ec289d0.svg";
export { ForwardRef as ReactComponent };